export default __webpack_public_path__ + "static/media/dark.27fdc7ed.svg";